import React, { Component, PropTypes } from 'react';
import { ProfilePage } from '../../../components/dashboard';
import DataProvider from '../dataProvider';
import {
  DashboardProfileTab,
  DashboardNoCurrentLeases,
  DashboardEmbed,
} from '../components';
import DetailsSidePanel from './DetailsSidePanel';
import * as routes from '../../../routes/const';
import {
  VEHICLE,
  DRIVER_SUGGESTIONS,
  VEHICLE_SUGGESTIONS,
  REPORT_HEADING,
  CARD_FLAG,
  REPORT_FLAG,
  LEASE_INFORMATION,
  VEHICLE_INFORMATION,
} from '../content';

import {
  transformTabs,
  transformDriverDetailsForSidePanel,
  transformLeaseDetailsForSidePanel,
} from '../helpers';
import { NitroLoading } from 'nitro-components/build/nitro';

class DashboardProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLeaseId: null,
      activeDriverId: null,
      selectedTab:
        this.props.profile.CurrentLeases && this.props.profile.CurrentLeases[0],
      openDetails: false,
      closeDetails: true,
    };

    this.openDetails = this.openDetails.bind(this);
    this.openCardDetails = this.openCardDetails.bind(this);
    this.fetchDetails = this.fetchDetails.bind(this);
  }

  // called when we click in any of the report cards /charts within the profile.
  openDetails = params => {
    const { profile } = this.props;
    this.setState({
      openDetails: true,
      closeDetails: false,
    });
    this.fetchDetails(params, REPORT_FLAG);
  };

  //dynamically fetch the card/report details
  fetchDetails = (obj, flag) => {
    switch (flag) {
      case REPORT_FLAG:
        this.props.actions.fetchReportDetail(obj);
        break;
      case CARD_FLAG:
        this.props.actions.fetchCardDetails(obj);
        break;
    }
  };

  //called when click of the cards in the profile pages
  openCardDetails = params => {
    const { profile } = this.props;
    console.log(params);

    let leaseId, companyCode, countryCode, driverId;

    if (this.props.location.state.dashboardType === 'driver') {
      leaseId = this.state.selectedTab.leaseId;
      companyCode = this.state.selectedTab.CompanyCode;
      (countryCode = profile.CountryCode), (driverId = profile.DriverId);
    } else if (this.props.location.state.dashboardType === 'vehicle') {
      leaseId = profile.LeaseId;
      companyCode = profile.CompanyCode;
      (countryCode = profile.CountryCode),
        (driverId = profile.CurrentDriver.DriverId);
    }

    const obj = Object.assign(params, {
      leaseId,
      companyCode,
      countryCode,
      driverId,
    });

    this.setState({
      openDetails: true,
      closeDetails: false,
      params: obj,
    });

    this.fetchDetails(obj, CARD_FLAG);
  };

  closeDetails = () => {
    this.setState({
      closeDetails: true,
      openDetails: false,
      detailsType: '',
    });
  };

  navigate = route => {
    const { profile } = this.props;
    const country = {
      value: profile.CountryCode,
      label: profile.CountryName,
    };

    const costcenter = {
      value: this.state.selectedTab.CompanyCode,
      label: this.state.selectedTab.CompanyName,
    };
    this.props.actions.setCountryConstCenterInsights([country, costcenter]);
    this.context.router.push({
      pathname: route,
    });
  };

  fetchProfile = (id, dashboardType) => {
    // pass current roleId. If not available the api fetches details of default role id
    const fetchParams = sessionStorage.getItem('roleId')
      ? { roleId: sessionStorage.getItem('roleId') }
      : {};

    fetchParams.countryCode = this.props.params.countryCode;
    //Api call to fecth driver profile
    this.props.actions.fetchProfile(fetchParams, id, dashboardType);

    this.setState({
      id,
    });
  };

  handleAllocation = () => {
    const {
      DriverId,
      DriverFirstName,
      DriverSurname,
      CompanyCode,
      CountryCode,
      CountryName,
      CompanyName,
    } = this.props.profile;

    const routerState =
      this.props.location.state.dashboardType === 'driver'
        ? {
            driverProfile: {
              DriverId,
              DriverFirstName,
              DriverSurname,
              CompanyCode,
              CountryCode,
              CountryName,
              CompanyName,
            },
          }
        : {
            vehicleAllocationData: this.props.profile,
          };

    this.context.router.push({
      pathname: routes.TRANSFERS_DRIVER,
      state: routerState,
    });
  };

  showHistoryDetails = () => {
    this.setState({
      closeDetails: false,
      openDetails: true,
    });

    const { LeaseId, CurrentLeases, PastLeases, history } = this.props.profile;

    if (this.props.location.state.dashboardType === 'driver') {
      const sidePanelDetails = transformLeaseDetailsForSidePanel(
        CurrentLeases,
        PastLeases,
        this.closeDetails
      );
      this.props.actions.setVehicleHistoryDetails(sidePanelDetails);
      return;
    }

    // No history data yet, need to fetch
    if (!history || !history.length) {
      // Driver history has own API
      this.props.actions.fetchVehicleHistoryDetails(LeaseId).then(res => {
        const driverList = res.value.data;
        const sidePanelDetails = transformDriverDetailsForSidePanel(
          driverList,
          this.closeDetails,
          this.handleAllocation
        );
        this.props.actions.setVehicleHistoryDetails(sidePanelDetails);
      });

      return;
    }

    const sidePanelDetails = transformDriverDetailsForSidePanel(
      history,
      this.closeDetails,
      this.handleAllocation
    );
    this.props.actions.setVehicleHistoryDetails(sidePanelDetails);
  };

  componentDidMount() {
    this.fetchProfile(this.props.params.refid, this.props.params.dashtype);
  }

  componentWillReceiveProps(nextProps) {
    const { refid: nextRefId, dashtype: nextDashType } = nextProps.params;
    const { refid: currRefId, dashtype: currDashType } = this.props.params;

    if (
      nextRefId &&
      (nextRefId !== currRefId || nextDashType !== currDashType)
    ) {
      this.fetchProfile(nextRefId, nextDashType);
      return;
    }

    // Exit if current lease hasn't changed
    const isDriverDashboard = nextDashType === 'driver';
    if (
      isDriverDashboard &&
      (!this.props.profile ||
        this.props.profile.CurrentLeases === nextProps.profile.CurrentLeases)
    ) {
      return;
    }
  }

  render() {
    const { actions, profile } = this.props;
    // const { tabs, selectedTab } = this.state;
    const { fetchingProfile } = profile;
    const { dashtype, countryCode } = this.props.params;

    let activeLeaseId,
      activeDriverId,
      driverId,
      reportId,
      registrationNo,
      contentId;

    if (fetchingProfile) {
      return <NitroLoading />;
    }

    reportId = profile.ProfileReportId;
    driverId = profile.DriverId;
    registrationNo = profile.RegistrationNo;
    contentId = profile.ProfileDashboardId;

    const profileCountryCode = profile.CountryCode;
    const profileCompanyCode = profile.CompanyCode;

    const isActive =
      (profile.CurrentLeases && profile.CurrentLeases.length > 0) ||
      (profile.PastLeases && profile.PastLeases.length > 0) ||
      typeof profile.CurrentDriver !== 'undefined';

    if (dashtype === 'driver') {
      if (profile.CurrentLeases && profile.CurrentLeases.length > 0) {
        activeLeaseId = profile.CurrentLeases[0].LeaseId;
      } else if (profile.PastLeases && profile.PastLeases.length > 0) {
        activeLeaseId = profile.PastLeases[0].LeaseId;
      }
    } else {
      if (profile.CurrentDriver) {
        activeDriverId = profile.CurrentDriver.DriverId;
      }
      registrationNo = profile.RegistrationNumber;
    }

    return (
      <div>
        {isActive ? (
          <DashboardEmbed
            dashboardType={dashtype}
            countryCode={profileCountryCode}
            companyCode={profileCompanyCode}
            reportId={reportId}
            driverId={driverId}
            activeLeaseId={activeLeaseId}
            activeDriverId={activeDriverId}
            registrationNo={registrationNo}
            contentId={contentId}
          />
        ) : (
          <DashboardNoCurrentLeases
            handleAllocation={this.handleAllocation}
            showHistoryDetails={this.showHistoryDetails}
            dashboardType={dashtype}
          />
        )}

        <DetailsSidePanel
          close={this.closeDetails}
          open={this.state.openDetails}
          detail={profile.detail}
          fetchingDetail={profile.fetchingDetail}
          detailsType={this.state.detailsType}
        />
      </div>
    );
  }
}
DashboardProfile.propTypes = {
  actions: PropTypes.shape({}),
  profile: PropTypes.object,
  location: PropTypes.object,
};

DashboardProfile.contextTypes = {
  router: PropTypes.object,
};

export default DataProvider(DashboardProfile);



// WEBPACK FOOTER //
// ./src/features/dashboard/containers/DashboardProfileV2.js